import { IFloorDetails, IPortfolioRegion, LocationWorkingHoursGroupI } from '@api'
import compose from 'lodash/fp/compose'
import filter from 'lodash/fp/filter'
import flatMap from 'lodash/fp/flatMap'
import groupBy from 'lodash/fp/groupBy'
import map from 'lodash/fp/map'
import isNull from 'lodash/isNull'

const groupFloorsByBookingWorkdayTime = groupBy(
  ({ bookingWorkdayTimeFrom, bookingWorkdayTimeTo }) =>
    `${bookingWorkdayTimeFrom}-${bookingWorkdayTimeTo}`
)

const filterFloorsByEmptyBookingWorkdayTime = filter(
  ({ bookingWorkdayTimeFrom, bookingWorkdayTimeTo }) =>
    !isNull(bookingWorkdayTimeFrom) && !isNull(bookingWorkdayTimeTo)
)

const mapGroupsByBookingWorkdayTime = map<IFloorDetails[], LocationWorkingHoursGroupI>((groups) => {
  const timeFrom = groups?.[0].bookingWorkdayTimeFrom || ''
  const timeTo = groups?.[0].bookingWorkdayTimeTo || ''

  return {
    timeFrom,
    timeTo,
    key: `${timeFrom}-${timeTo}`,
    isChanged: false,
    isLoading: false,
    isBeingEdited: false,
    isNewItem: false,
    floorIds: groups.map(({ id }) => id),
  }
})

type GetWorkingHoursGroupsByRegions = (region: IPortfolioRegion[]) => LocationWorkingHoursGroupI[]

const getWorkingHoursGroupsByRegions = compose(
  mapGroupsByBookingWorkdayTime,
  groupFloorsByBookingWorkdayTime,
  filterFloorsByEmptyBookingWorkdayTime,
  flatMap('floors'),
  flatMap('buildings'),
  flatMap('cities')
) as GetWorkingHoursGroupsByRegions

export default getWorkingHoursGroupsByRegions
